export default "__VITE_ASSET__DQohU57f__"